define('common/formatter',[
],
    function () {

        var spinnerShownAt = {};

        function money(someNumber, hideZeroAmount) {
            try {
                if (hideZeroAmount && someNumber == 0) return "";
                if (CP.SessionContext.SiteName === "cpus") {
                    var fmtUS = new Intl.NumberFormat('en-US', {
                        style: 'currency',
                        currency: 'USD'
                    });
                    return fmtUS.format(someNumber).replace(".00", "");
                }
            }
            catch (error) {
                return someNumber;
            }
        }

        return {
            money: money
        };
    });

